import { tns } from 'tiny-slider/src/tiny-slider'


function slider2(el) {
	const carouselEl = el.querySelector('.logo-carousel__slides')
	if (!carouselEl) return null

	// const carouselNav = el.querySelector('.content-carousel__navigation')
	// const carouselControl = el.querySelector('.content-carousel__controls')

	// remove classes for setting pagewidth before carousel inits
	//carouselEl.classList.remove('grid')
	//carouselEl.classList.remove('page-width')

	return tns({
		container: carouselEl,
		items: 2,
		controls : false,
		nav: false,
		navPosition: 'bottom',
		touch: true,
		mouseDrag: true,
		loop: true,
		autoplay: true,
		speed: 500,
		autoplayTimeout: 3500,
		autoplayButtonOutput: false,	
		responsive : {
			450 : { items : 2  },
			608 : { items : 2 },
			880 : { items : 3 },
			1500 : { items : 4 },
			2000 : { items : 6 },
		}	
	})
}

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/logo-carousel.default', function($scope, $) {
		const el = $scope.get(0)
		if (el) slider2(el)
	});
})
